import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=20b05fbe&scoped=true"
import script from "./Redirection.vue?vue&type=script&lang=js"
export * from "./Redirection.vue?vue&type=script&lang=js"
import style0 from "./Redirection.vue?vue&type=style&index=0&id=20b05fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b05fbe",
  null
  
)

export default component.exports